import {siteName} from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "Do you have a stash of Chase Ultimate Rewards® points and dream of turning them into the ultimate vacation? Chase Ultimate Rewards points are a treasure trove of value in the world of travel, and here's why: you can seamlessly transfer these points to airline partners, opening the door to incredible award flights and hotel stays.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Select Your Airline Partner",
      description:
        "The journey begins by choosing the airline partner that suits your travel plans. Chase offers a diverse array of airline partners, from United Airlines and British Airways to Southwest Airlines, among others.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      // title: "2. Connect Your Loyalty Accounts and Initiate the Points Transfer",
      description:
        "To explore the complete list of Chase airline partners, simply log in to your Chase account and head to the Chase Ultimate Rewards portal. There, you'll find the \"Transfer to Travel Partners\" tab, where you'll discover the comprehensive list of airline and hotel partners.",
      img: "https://img.awardtool.com/guides/chase_1.jpg",
    },
    {
      title: "2. Connect Your Loyalty Accounts",
      description:
        'Once you\'ve made your choice of an airline partner, the subsequent step involves linking your loyalty accounts. This entails inputting your frequent flyer number for the selected airline partner. To execute this, choose the airline partner for your points transfer. Subsequently, enter your frequent flyer number for that specific airline and click "Continue."',
      img: "https://img.awardtool.com/guides/chase_2_2.jpg",
    },

    {
      // title: "3. Execute the Points Transfer",
      description: "Enter your frequent flyer number for that airline.",
      img: "https://img.awardtool.com/guides/chase_3.png",
    },
    {
      title: "3. Execute the Points Transfer",
      description:
        'After successfully linking your loyalty accounts, the next step is to carry out the transfer of your Chase Ultimate Rewards points to your chosen airline partner. Specify the number of points you wish to transfer and click "Next". Typically, the transfer is instantaneous, but there are scenarios where it may take up to 24 hours or more. Typically, the point transfers maintain a 1:1 ratio for Chase Ultimate Rewards, with occasional bonus transfer offers from Chase.',
      // img: "https://img.awardtool.com/guides/chase_4.png",
    },

    {
      // title: "3. Execute the Points Transfer",
      description:
        'You\'ll have the opportunity to review your points transfer details, including your starting balance, ending balance, the Chase account you\'re transferring from, and your airline partner account. Keep in mind that point transfers are irreversible once you click \"Submit.\"',
      img: "https://img.awardtool.com/guides/chase_4.png",
    },
    {
      title: "4. Secure Your Award Flight",
      description:
        "After successfully transferring your Chase Ultimate Rewards points to your airline partner, the final step entails booking your award flight. To accomplish this, log in to your airline loyalty account and initiate a search for available award flights. To save time, you can simplify this process by utilizing " + siteName + " to search for award flights across major airline loyalty programs, rather than navigating to each airline's website individually.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      // title: "8. How can you review, update or delete the data we collect from you?",
      description:
        "Keep in mind that the availability of award flights can fluctuate, so it's recommended to conduct your search well in advance of your intended travel date. Additionally, it's always prudent to confirm the desired award flight directly through the airline's website before initiating the transfer of your Chase Ultimate Rewards points, as point transfers are irreversible.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
